import React from "react";
import { FaBell } from "react-icons/fa";
import "./style/Toast.css";

const Toast = ({ message, onClose }) => {
    if (!message) return null;
    return (
        <div className="toast-container">
            <FaBell className="toast-icon" />
            <span className="toast-message">{message}</span>
            <button className="toast-close-btn" onClick={onClose}>×</button>
        </div>
    );
};

export default Toast;